import { Route } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import NewOnboarding from "../pages/New_Onboarding";
import ToStartDetail from "../pages/New_Onboarding/components/ToStartDetail";
import Suivi from "../pages/New_Onboarding/components/suivi";

export const onBoardingRoutes = (
    <>
        <Route
            path={ROUTES.onboarding.home}
            element={<NewOnboarding />}
            key="onboarding_home"
        />
        <Route
            path={ROUTES.onboarding.detail}
            element={<ToStartDetail />}
            key="onboarding_detail"
        />
        <Route
            path={ROUTES.onboarding.suivi}
            element={<Suivi />}
            key="onboarding_suivi"
        />
    </>
);
